import './adults.css'

const AdultsCount = (props: any) => {
    const { node, data, change } = props;
    const updateCount = (flag: number, key: string, node: any, value: any, type: any) => {

        let updateData = [...data];
        let a = {
            name: 'Age',
            title: 'childAge',
            value: 0,
            type: 'age'
        };
        let filter: any;
        filter = updateData.filter((n: any) => {
            return n.name === node.name;
        });


        if (value >= 0) {
            if (filter[0]) {
                if (key === 'adult') {
                    value === 0 ? filter[0].value = 1 : filter[0].value = value;
                }
                else filter[0].value = value
            }
            if (key === 'child') {
                if (type === '+') {
                    node?.children.push(a)
                }
                if (type === '-') {
                    node?.children.pop(a)
                }

            }
            change([...updateData])
        }



    }
    const updateChildAge = (value: any, index: number, age: any) => {
        let updateData = [...data];
        let filter: any;

        filter = updateData.filter((n: any) => {
            return n.name === 'kidsCount';
        });
        if (filter[0]) {

            filter[0].children[index].value = +value;
        }
        change([...updateData])
    }

    return <div className="roomContainer">
        {node.title === 'Adults' ? <div className="flex roomAction">
            <div className="nme">Adults
                <div className="age">
                    Aged 13 +</div></div>
            <div className="actionBox">
                <div className={node.value <= 1 ? "roomBtn disabled" : "roomBtn"} onClick={() => updateCount(-1, 'adult', node, node?.value - 1, "-")}><div className="sub">-</div></div>
                <div className="roomCount"><div className="count">{node?.value}</div></div>
                <div className={"roomBtn"} onClick={() => updateCount(-1, 'adult', node, node?.value + 1, "+")}><div className="sub">+</div></div>
            </div>
        </div> :
            node.title === 'Childrens' ? <div className="flex roomAction">
                <div className="nme">Children</div>
                <div className="actionBox">
                    <div className={node?.value <= 0 ? "roomBtn disabled" : "roomBtn"} onClick={() => updateCount(-1, 'child', node, node?.value - 1, "-")} ><div className="sub">-</div></div>
                    <div className="roomCount"><div className="count">{node?.value}</div></div>
                    <div className={"roomBtn"} onClick={() => updateCount(-1, 'child', node, node?.value + 1, "+")} ><div className="sub">+</div></div>
                </div>
            </div> : null}

        {node.title === 'Childrens' ? <div>
            {node?.value > 0 ?
                node?.children.map((n: any, index: number) => {
                    return <div className="ChildrenAgeSet" key={index}>
                        <div className="ChildAge">Child {index + 1} age</div>
                        <input className="selectage" onChange={(e) => updateChildAge(e.target.value, index, n)} placeholder="Type age here" />
                    </div>
                })
                : null}
        </div> : null}
    </div>
}

export default AdultsCount